'use client';

import { useAppSelector } from '@/hooks/reduxHooks';
import { Box } from '@mantine/core';
import React from 'react';

type Props = {
  children: React.ReactNode;
};

export const MiddleWrapper = ({ children }: Props) => {
  const theme = useAppSelector((state) => state.theme.theme);
  return (
    <Box
      className={`relative z-50 h-full w-full lighter-shape-${theme === 'light' ? 'light-' : ''}background`}
      style={{
        width: '100%',
        height: '100%',
        overflow: 'visible',
      }}
    >
      <Box className="flex w-full flex-col">{children}</Box>
    </Box>
  );
};
